// Base form options that can be shared across different forms
export const baseFormOptions = {
  countries: [
    "Australia",
    // "New Zealand",
    // "United States",
    // "United Kingdom",
    // "Canada",
    "Other"
  ],

  allCountries: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darrussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos Islands",
    "Colombia",
    "Comoros",
    "Congo, Democratic Republic of the",
    "Congo, Republic of the",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czech Republic",
    "Côte d'Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini (Swaziland)",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard and McDonald Islands",
    "Holy See",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Korea",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Réunion",
    "Saint Barthélemy",
    "Saint Helena",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen Islands",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "US Minor Outlying Islands",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Virgin Islands, British",
    "Virgin Islands, U.S.",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland Islands"
  ],

  // States/provinces by country
  statesByCountry: {
    "Australia": [
      { code: "NSW", name: "New South Wales" },
      { code: "VIC", name: "Victoria" },
      { code: "QLD", name: "Queensland" },
      { code: "WA", name: "Western Australia" },
      { code: "SA", name: "South Australia" },
      { code: "TAS", name: "Tasmania" },
      { code: "NT", name: "Northern Territory" },
      { code: "ACT", name: "Australian Capital Territory" }
    ],
    "New Zealand": [
      { code: "AUK", name: "Auckland" },
      { code: "BOP", name: "Bay of Plenty" },
      { code: "CAN", name: "Canterbury" },
      { code: "CIT", name: "Chatham Islands" },
      { code: "GIS", name: "Gisborne" },
      { code: "HKB", name: "Hawke's Bay" },
      { code: "MWT", name: "Manawatu-Whanganui" },
      { code: "MBH", name: "Marlborough" },
      { code: "NSN", name: "Nelson" },
      { code: "NTL", name: "Northland" },
      { code: "OTA", name: "Otago" },
      { code: "STL", name: "Southland" },
      { code: "TKI", name: "Taranaki" },
      { code: "TAS", name: "Tasman" },
      { code: "WKO", name: "Waikato" },
      { code: "WGN", name: "Wellington" },
      { code: "WTC", name: "West Coast" }
    ],
  },

  // Backward compatibility: expose Australia states as default 'states'
  get states() {
    return this.statesByCountry.Australia;
  },
  
  businessTypes: [
    "Private Company",
    "Public Company",
    "Sole Trader",
    "Partnership",
    "Trust",
    "Other"
  ],
  
  industries: [
    "Manufacturing",
    "Wholesale",
    "Healthcare",
    "Pharmaceutical",
    "Food & Beverage",
    "Retail",
    "Labour Hire",
    "Materials",
    "Transport & Logistics",
    "eCommerce",
    "Agribusiness",
    "Accounting",
    "IT Hardware & Equipment",
    "Construction & Engineering",
    "Other"
  ],
  
  employeeRanges: [
    "1 – 4 (Micro business)",
    "5 – 19 (Small business)",
    "20 – 199 (Medium business)",
    "200+ (Large business)",
  ],
  
  customerRanges: [
    "1 – 10",
    "11 – 50",
    "51 – 100",
    "101 – 500",
    "501 – 1,000",
    "1,000+"
  ],
  
  turnoverRanges: [
    "$0 - $999,999",
    "$1,000,000 - $2,999,999",
    "$3,000,000 - $9,999,999",
    "$10,000,000 - $49,999,999",
    "$50,000,000+"
  ],
  invoiceRanges: [
    "$0 - $99,999",
    "$100,000 - $249,999",
    "$250,000 - $499,999",
    "$500,000 - $999,999",
    "$1,000,000 - $1,999,999",
    "$2,000,000+"
  ],

  supplierRanges: [
    "1 – 5",
    "6 – 20", 
    "21 – 50",
    "51 – 100",
    "100+"
  ],
  
  netAssetsRanges: [
    "$0 - $499,999",
    "$500,000 - $1,999,999",
    "$2,000,000 - $9,999,999",
    "$10,000,000 - $24,999,999",
    "$25,000,000+"
  ],
  
  bestDescribesYouOptions: [
    "Broker / Finance adviser",
    "Accountant / Bookkeeper",
    "Consultant / Advisor",
    "Supplier / Vendor",
    "Other"
  ],
  
  numberOfClientsRanges: [
    "1 - 10",
    "11 - 50",
    "51 - 100",
    "101 - 500",
    "500+"
  ],
  
  // Form-specific options moved to individual form configs
  // financingTypes, suitabilityCriteria, etc. are now defined in their respective form configs
  
  titles: [
    "Mr",
    "Mrs",
    "Miss",
    "Ms",
    "Dr",
    "Prof",
    "Other"
  ],
  
  referralSources: [
    "Online search (Google, Bing, ChatGPT, etc.)",
    "Business referral (e.g. accountant, client, partner)",
    "Financial adviser or broker",
    "You called me",
    "LinkedIn",
    "Social media",
    // "Octet website",
    "Online advertising",
    "Online article or blog",
    "Event or trade show",
    "Email or newsletter",
    // "Existing relationship with Octet",
    "Outdoor advertising",
    "Radio or podcast",
    "TV",
    "Comparison site",
    "Other"
  ]
};

// Type for form options to ensure type safety
export type BaseFormOptions = typeof baseFormOptions;

// Helper function to merge base options with custom overrides
export function createFormOptions<T extends Record<string, unknown>>(overrides: T = {} as T): BaseFormOptions & T {
  return {
    ...baseFormOptions,
    ...overrides,
  } as BaseFormOptions & T;
}

// Utility functions for dynamic state selection
export function getStatesForCountry(country: string): { code: string; name: string }[] {
  if (country === "Other" || !country) {
    return [];
  }
  
  return baseFormOptions.statesByCountry[country as keyof typeof baseFormOptions.statesByCountry] || [];
}

export function shouldUseTextInput(country: string): boolean {
  // Use dropdown for Australia and New Zealand, text input for all other countries
  // Also use text input for countries without predefined states
  return !(country === "Australia" || country === "New Zealand") || getStatesForCountry(country).length === 0;
}

export function getStateFieldLabel(country: string): string {
  switch (country) {
    case "Australia":
    case "New Zealand":
      return "State";
    case "United States":
      return "State";
    case "Canada":
      return "Province";
    case "United Kingdom":
      return "State";
    case "Other":
      return "State / Region";
    default:
      return "State / Region";
  }
}

export function getStateFieldPlaceholder(country: string): string {
  switch (country) {
    case "Australia":
      return "Select state";
    case "New Zealand":
      return "Select state";
    case "United States":
      return "Select state";
    case "Canada":
      return "Select province";
    case "United Kingdom":
      return "Select state";
    case "Other":
      return "Enter state, province, or territory";
    default:
      return "Select or enter state / region";
  }
}
